import { yupResolver } from "@hookform/resolvers/yup";
import CheckIcon from "@mui/icons-material/Check";
import { Button, Grid, TextField } from "@mui/material";
import RadioBtn from "components/Attendance/RadioBtn";
import BackButton from "components/shared/BackButton";
import DatePickerCM from "components/shared/DatePicker";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import TableCM from "components/shared/Table";
import GenarateHeadCell from "helper/generate-head-cell";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { attendanceSchema } from "validations";
import {
  ButtonContainer,
  StyledDateBox,
  StyledStack,
  StyledTitle,
} from "./AddAttendace.style";
import { addAttendaceRequest, getStudentsListRequest } from "api/requests";
import { convertNum } from "helper/convert-num";
import { convertToUniqueArrayObject } from "helper/data-converter";

const headCells = GenarateHeadCell("teacher_user_attendance");
const students = [];

export default function TeacherAddAttendance() {
  const { loading, request, setLoading } = useHttp();

  // get class_id from url
  const { class_id } = useParams();

  // data picker stat
  const [date, setDate] = useState(null);

  const [page] = useState(1);

  // students data state
  const [attendanceUser, setAttendanceUser] = useState({ data: [], count: 0 });

  const navigate = useNavigate();
  const onDateChange = (value) => {
    setDate(value);
  };

  // handle change student status
  const onAttendanceChange = (value) => {
    students.push({
      ...value,
      student_id: `${value.student_id}`,
    });
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(attendanceSchema),
  });

  // get class students list
  const getUsers = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getStudentsListRequest,
      values: {
        skip: 0,
        limit: 100,
        class_id,
      },
      isMulty: true,
    });
    if (res.count < 1) {
      return setAttendanceUser({
        count: res.count,
        data: [{ content: "هیچ دانش آموزی یافت نشد" }],
      });
    }
    setLoading(false);
    if (res) {
      const myList = res.data;
      const collator = new Intl.Collator("fa");
      const sortedLetters = myList.sort((a, b) =>
        collator.compare(a.last_name, b.last_name)
      );
      let transformedData = sortedLetters.map((items) => ({
        id: items.id,
        fullName: `${items.first_name} ${items.last_name}`,
        level: items?.level ?? "ثبت نشده",
        national_code: items.national_code,
        userAttendance: (
          <RadioBtn id={items.id} onAttendanceChange={onAttendanceChange} />
        ),
      }));
      setAttendanceUser({ data: transformedData, count: 5 });
    }
  }, [class_id, request, setLoading]);

  // add new class attendance
  const onSubmit = async () => {
    const transformedData = {
      date: date
        .format("YYYY-MM-DD")
        .split("-")
        .map((item) => convertNum(item))
        .join("-"),
      students: convertToUniqueArrayObject({
        array: students,
        index: "last",
        key: "student_id",
      }),
      class_id,
    };

    const res = await request({
      url: addAttendaceRequest,
      values: transformedData,
    });

    if (res) {
      Toast({ type: "success", title: "ثبت حضور و غیاب" });
      reset({
        date: "",
      });
      navigate(`/teacher_classes/${class_id}/attendance/`);
    }
  };

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  return (
    <DrawerCM title="ثبت حضور و غیاب" $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container my={2}>
            <Grid item xs={12}>
              <BackButton />
            </Grid>
          </Grid>
          <StyledStack>
            <StyledTitle>تاریخ حضور غیاب</StyledTitle>
            <Grid container>
              <Grid item md={6} xs={12} p={1.5}>
                <StyledDateBox>
                  <DatePickerCM
                    onChange={onDateChange}
                    render={(value, openCalendar) => {
                      return (
                        <TextField
                          fullWidth
                          onClick={openCalendar}
                          value={value ? value : ""}
                          label="انتخاب تاریخ"
                          variant="outlined"
                          id="date"
                          {...register("date")}
                          error={Boolean(errors.date)}
                          helperText={errors.date?.message}
                        />
                      );
                    }}
                  />
                </StyledDateBox>
              </Grid>
            </Grid>
          </StyledStack>
          <Grid item xs={12} my={2}>
            <TableCM
              title="لیست دانش آموزها"
              rows={attendanceUser.data}
              headCells={headCells}
              page={page}
            />
          </Grid>
          <ButtonContainer>
            <Button
              startIcon={<CheckIcon />}
              variant="contained"
              sx={{ mt: 1 }}
              onClick={handleSubmit(onSubmit)}
            >
              ذخیره
            </Button>
          </ButtonContainer>
        </Fragment>
      )}
    </DrawerCM>
  );
}
